module.exports = __webpack_public_path__ + "fonts/tenez-light.6922289.otf";